import { gql, useMutation } from "@apollo/client";
import {
    GQLCompleteSocialConnectionMutation,
    GQLCompleteSocialConnectionMutationVariables,
    GQLDisconnectSocialAccountMutation,
    GQLDisconnectSocialAccountMutationVariables,
    GQLInitiateSocialConnectionMutation,
    GQLInitiateSocialConnectionMutationVariables,
} from "@components/network-connector/network-connector.gql.generated";

export const networkConnectorUserSocialAccountFragment = gql`
    fragment NetworkConnectorUserSocialAccount on SocialAccount {
        channel
        isConnected
        lastConnection
        metadata
        providerAccountId
        refreshToken
        scope
        tokenExpiresAt
    }
`;

export const networkConnectorUserFragment = gql`
    fragment NetworkConnectorUser on User {
        id
        email
        socialAccounts {
            ...NetworkConnectorUserSocialAccount
        }
    }
    ${networkConnectorUserSocialAccountFragment}
`;

export const NETWORK_CONNECTOR_QUERY = gql`
    query NetworkConnector {
        me {
            ...NetworkConnectorUser
        }
    }
    ${networkConnectorUserFragment}
`;

export const DISCONNECT_SOCIAL_ACCOUNT_MUTATION = gql`
    mutation DisconnectSocialAccount($channel: Channel!) {
        disconnectSocialAccount(channel: $channel) {
            status
            error {
                code
            }
        }
    }
`;

export const useDisconnectSocialAccountMutation = () => {
    const [disconnectSocialAccount, { loading, error, data }] = useMutation<
        GQLDisconnectSocialAccountMutation,
        GQLDisconnectSocialAccountMutationVariables
    >(DISCONNECT_SOCIAL_ACCOUNT_MUTATION);

    return {
        disconnectSocialAccount,
        loading,
        error,
        data,
    };
};

export const INITIATE_SOCIAL_CONNECTION_MUTATION = gql`
    mutation InitiateSocialConnection($channel: Channel!, $redirectUri: String!) {
        initiateSocialConnection(channel: $channel, redirectUri: $redirectUri) {
            authUrl
            state
            error {
                code
            }
        }
    }
`;

export const useInitiateSocialConnectionMutation = () => {
    const [initiateSocialConnection, { loading, error, data }] = useMutation<
        GQLInitiateSocialConnectionMutation,
        GQLInitiateSocialConnectionMutationVariables
    >(INITIATE_SOCIAL_CONNECTION_MUTATION);

    return {
        initiateSocialConnection,
        loading,
        error,
        data,
    };
};

export const COMPLETE_SOCIAL_CONNECTION_MUTATION = gql`
    mutation CompleteSocialConnection($channel: Channel!, $code: String!, $redirectUri: String!, $state: String!) {
        completeSocialConnection(channel: $channel, code: $code, redirectUri: $redirectUri, state: $state) {
            socialAccount {
                channel
            }
            error {
                code
            }
        }
    }
`;

export const useCompleteSocialConnectionMutation = () => {
    const [completeSocialConnection, { loading, error, data }] = useMutation<
        GQLCompleteSocialConnectionMutation,
        GQLCompleteSocialConnectionMutationVariables
    >(COMPLETE_SOCIAL_CONNECTION_MUTATION);

    return {
        completeSocialConnection,
        loading,
        error,
        data,
    };
};
